export const kitchenSinkRules = (): void => {
    // todo
};
